import React, { useContext } from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import AppBarContext, { useAppBarContext } from '../../../context/AppBarContext';
import { styled as mustyled } from '@mui/material/styles';
import { ButtonBase } from '@mui/material'; // Import the context you've created

const CustomButtonBase = mustyled(ButtonBase)(({ theme }) => ({
  marginRight: theme.spacing(2),
  textAlign: 'center',
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(1),
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)', // Ensure this is subtle
    '& .MuiTypography-root': { // Targeting Typography within the component
      color: '#2E3B55', // Choose a color that stands out against the hover background
      textShadow: '0px 0px 3px rgba(255,255,255,0.9)', // Adding shadow to enhance visibility
    },
    '& .MuiSvgIcon-root': { // Targeting MUI SVG Icons within the component
      color: '#2E3B55', // Ensure this color stands out against the hover background
      filter: 'drop-shadow(0px 0px 2px rgba(255,255,255,0.9))', // Adding shadow to enhance visibility
    },
  },
}));
const InternalAppBar = () => {
  const { appBarConfig } = useAppBarContext(); // Assuming you've adjusted the context to provide appBarConfig too
  const { isLoading, actions } = appBarConfig || { isLoading: false, actions: [] };


  return (
    actions ? (<AppBar position='static' color='default' elevation={0}
             style={{ backgroundColor: 'white', margin: '0', padding: '0' }}>
      <Toolbar variant='dense'>
        {actions && actions.map(action =>
          <CustomButtonBase
            onClick={!isLoading ? action.onClick : null}
            disabled={isLoading}
            style={{
              marginRight: '8px',
              textAlign: 'center',
              display: 'inline-flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            {action.icon}
            <Typography variant='caption' style={{ marginLeft: 8 }}>{action.label}</Typography>
          </CustomButtonBase>
        )}
      </Toolbar>
    </AppBar>):null
  );
};

export default InternalAppBar;